import Hero from './components/Hero'

const Welcome = () => <Hero />

export default Welcome
